export default {
  label: {
    cancelLabel: 'Cancel',
    cardLabel: 'Remove',
    modalTitle: 'Remove component',
    modalText: 'Are you sure you want to remove the component?',
  },
};
